module.exports = __webpack_public_path__ + "img/1-05.eb8bf2d3.jpg";